import {CreateSessionMultiStepForm} from "../multi-step-form";

export function CreateSessionMultiStepFormWrapper() {
  return <CreateSessionMultiStepForm />;
}
